import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../app/store';
//import axios from 'axios';

interface FilterState {
  showCareCenters: any;
  showWarriors: any;
  unknownIsGood: boolean
}

interface TypeSelection { type: string, isVisible: boolean }
// Define action types

// interface ShowCareCentersAction extends Action {
//   type: 'filter/showCareCenters';
//   payload:  TypeSelection | boolean;
// }
const initialState: FilterState = {
  // Clinical trials default to OFF for both phase bands — 'TR1,2,3' ("Phase I/II") and
  // 'TR4,5' ("Phase III/IV"). The user opts in via the filter toggles.
  // These keys are only consulted on CT-condition maps (isCTCondition); inert on maps that don't show trials.
  // Off also means neither useGetClinicalTrialsQuery fires on load (both args are skipToken).
  showCareCenters: { E: true, S: true, C: false, H: false, 'TR1,2,3': false, 'TR4,5': false, WALK: true },
  showWarriors: { P: true, C: true, M: true },  //P for patients or warriors
  unknownIsGood: true
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    showCareCenters: (state, action: PayloadAction<TypeSelection | boolean>) => {
      //state.showCareCenters = action.payload;
      if (typeof action.payload === 'boolean') {
        state.showCareCenters = action.payload;
        state.unknownIsGood = action.payload
        return
      }
      // if (typeof state.showCareCenters === 'boolean') {
      //   state.showCareCenters = {}
      // }
      //state.showCareCenters[action.payload.type] = action.payload.isVisible
      state.showCareCenters = { ...state.showCareCenters, [action.payload.type]: action.payload.isVisible }
    },
    showWarriors: (state, action) => {
      if (typeof action.payload === 'boolean') {
        state.showWarriors = action.payload;
        state.unknownIsGood = action.payload
        return
      }
      // if (typeof state.showWarriors === 'boolean') {        
      //   state.showWarriors = {}
      // }
      //state.showWarriors[action.payload.type] = action.payload.isVisible
      state.showWarriors = { ...state.showWarriors, [action.payload.type]: action.payload.isVisible }
    },
    showInitialFilters: (state) => {
      Object.assign(state, initialState);
    },
    setlFilters: (state, action) => {
      Object.assign(state, action.payload);
    }
  },
  extraReducers: (builder) => {

  }

});

export const { showCareCenters, showWarriors, showInitialFilters, setlFilters } = filterSlice.actions;
export const filterSelector = (state: RootState) => state.filter;
export default filterSlice.reducer;
